// The theme's built-in product-sticky-bar hides itself the instant the footer starts entering the
// viewport, rather than once the user has actually scrolled through it. This adds a second visibility
// trigger (a supplementary class, not fighting the native one) that keeps the bar shown until the user
// reaches the true bottom of the page.
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('.product-sticky-bar');

  if (!bar) {
    return;
  }

  var formId = bar.getAttribute('form');
  var form = formId ? document.forms[formId] : null;

  if (!form) {
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;

    var formPastView = form.getBoundingClientRect().bottom < 0;
    var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

    bar.classList.toggle('js-extend-visible', formPastView && !atBottom);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
});
